export default __webpack_public_path__ + "static/media/mail.e8edf017.png";